<div class="reports-list-container" *ngIf="!loadingReports">
  <div class="list-container-contents">
    <ng-container *ngIf="reportList$ | async as reportList">
      <div
        class="report-option"
        [class.current]="report.uid === currentReport?.uid"
        *ngFor="let report of reportList"
        (click)="selectReport(report)"
      >
        <div class="report-title">
          {{ setReportTitle(report) }}
        </div>
        <div class="report-slide-toggle">
          <p>{{ report.active ? 'Active' : 'Inactive' }}</p>
          <mat-slide-toggle
            [checked]="report.active"
            (change)="reportStatusUpdate($event.checked, report)"
            (click)="$event.stopPropagation()"
          ></mat-slide-toggle>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="list-container-actions">
    <div class="option" (click)="createReport()" id="create-report">
      <mat-icon>add</mat-icon>
      <div class="action-label">Create Report</div>
    </div>
  </div>
</div>
<div class="loading-reports" *ngIf="loadingReports">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
